import React, { PropsWithChildren } from 'react';

type TreeProps = {};

const Tree = (props: PropsWithChildren<TreeProps>) => {
  return <div className="Tree">{props.children}</div>;
};

export default Tree;
